import { ACCESS_TOKEN, API_BASE_URL_DOCUMENT } from './config.js';
import _, { isArray } from 'lodash';
import { message, notification } from 'antd';

import React from 'react';
import { encrypt } from './crypto';
import getEnvValue from './getEnvValue';
import handleErrors from './handleErrors';

type Method = 'GET' | 'POST' | 'DELETE' | 'PUT' | 'PATCH';

type Options = {
  url: string;
  method: Method;
  body?: any;
};

export function request<Data = any>(options: Options): Promise<Data>;
// eslint-disable-next-line no-redeclare
export function request<Data = any>(
  url: string,
  options: Omit<Options, 'url'>
): Promise<Data>;
// eslint-disable-next-line no-redeclare
export function request<Data = any>(
  optionsOrUrl: Options | string,
  maybeOptions?: Omit<Options, 'url'>
): Promise<Data> {
  let url = typeof optionsOrUrl === 'string' ? optionsOrUrl : optionsOrUrl.url;
  const options =
    typeof optionsOrUrl === 'string' ? maybeOptions : optionsOrUrl;

  const { body, method, ...otherOptions } = options as Options;

  const headers = new Headers({
    'Content-Type': 'application/json',
  });

  if (
    // process.env.NODE_ENV === 'production' ||
    getEnvValue('REACT_APP_ENV_MODE') === 'PROD'
  )
    url =
      url.slice(0, url.indexOf('/api') + 5) +
      encrypt(url.slice(url.indexOf('/api') + 5, url.length));

  const accessToken = localStorage.getItem(ACCESS_TOKEN);

  if (accessToken !== 'undefined' && accessToken != null) {
    headers.append('Authorization', `Bearer ${accessToken}`);
  } else {
    headers.append('Authorization', 'Bearer');
  }
  headers.append('Dev-Stage', 'true');

  const defaults = { headers, mode: 'cors' as const };

  const requestOptions = Object.assign({}, defaults, {
    method,
    body:
      body !== undefined && typeof body !== 'string'
        ? JSON.stringify(body)
        : body,
    ...otherOptions,
  });

  return fetch(url, requestOptions)
    .then(handleErrors)
    .then((response) => {
      return response?.json()?.then((json) => {
        if (json.code !== undefined) {
          // if (json.code === "417") {
          //   try {
          //     let errormsg: any
          //     if (json.description) {
          //       const listError = JSON.parse(json.description)
          //       if (isArray(listError)) {
          //         errormsg = React.createElement(
          //           "div",
          //           { style: { display: "flex", flexDirection: "column", gap: "8px" } },
          //           listError.map((error: any, index: number) => {
          //             return React.createElement(
          //               "div",
          //               {
          //                 key: index,
          //                 style: {
          //                   fontSize: "14px",
          //                   color: "#000000",
          //                   fontWeight: "500",
          //                   lineHeight: "1.5",
          //                 },
          //               },
          //               error.message,
          //             )
          //           }),
          //         )
          //       } else {
          //         errormsg = listError
          //       }
          //     }
          //     // notification.error({
          //     //   description: errormsg,
          //     //   message: React.createElement("span", { style: { fontWeight: "700", color: "#000000" } }, json.message),
          //     //   className: "error417",
          //     //   style: {
          //     //     width: 450,
          //     //     padding: "12px 16px",
          //     //     marginLeft: 0,
          //     //   },
          //     // })
          //     return Promise.reject(json)
          //   } catch (Exception) {
          //     notification.error({
          //       description: json.description,
          //       message: json.message,
          //     })
          //   }
          // }
          if (json.code === '500') {
            notification.error({
              description: json.description,
              message: json.message,
            });
          }
          if (json.code === '401') {
            notification.error({
              description: json.description ?? 'Session Timeout',
              message: json.message,
            });
            localStorage.removeItem('changepassword');
            localStorage.removeItem('token');
            localStorage.clear();
            window.history.replaceState(null, '', '/login');
            window.location.reload();
          }

          if (json.code === '403') {
            notification.error({
              description: json.description,
              message: json.message,
            });
            // window.history.replaceState(null, '', '/403');
            // window.location.reload();
          }
        }

        if (!response.ok) {
          try {
            if (json.status === '500') {
              message.error(`${json.status}: ${json.message}`);
            }
          } catch (err) {
            let service = url.substring(
              url.indexOf('/', 10) + 1,
              url.indexOf('/api/', 1)
            );
            message.warning({
              content: `${service} is not available`,
              style: {
                fontSize: 18,
              },
            });
          }
          return Promise.reject(json);
        }

        return json;
      });
    });
}

request.get = <Data = any>(url: string) => {
  return request<Data>(url, { method: 'GET' });
};
request.delete = <Data = any>(url: string, body?: any) => {
  return request<Data>(url, { method: 'DELETE', body });
};
request.post = <Data = any>(url: string, body?: any) => {
  return request<Data>(url, { method: 'POST', body });
};
request.patch = <Data = any>(url: string, body?: any) => {
  return request<Data>(url, { method: 'PATCH', body });
};
request.put = <Data = any>(url: string, body?: any) => {
  return request<Data>(url, { method: 'PUT', body });
};
export async function UploadDocumentFile(file: any, objectReference: string) {
  const formData = new FormData();
  formData.append('file', file);
  const accessToken = localStorage.getItem(ACCESS_TOKEN);

  objectReference = objectReference + '_' + Math.round(_.random(1000, 9999));

  try {
    const res = await fetch(
      `${API_BASE_URL_DOCUMENT}/upload?objectReference=`,
      {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (res.status === 200) {
      const result = await res.json();
      console.log('+++', result); 
      return result; 
    } else {
      console.log('___test', res);
      try {
        const _res = await res.json();
        console.log('+++', _res); 
        return {
          code: _res.status,
          message: _res.message,
          // description: _res.message,
        };
      } catch (error) {
        message.error('Error');
        return { code: '500', message: 'Error parsing response' };
      }
    }
  } catch (error) {
    message.error('Error');
    return { code: '500', message: 'Request failed' };
  }
}

// export async function UploadDocumentFile(file: any, objectReference: string) {
//   const formData = new FormData();

//   formData.append('file', file);
//   const accessToken = localStorage.getItem(ACCESS_TOKEN);

//   objectReference = objectReference + '_' + Math.round(_.random(1000, 9999));

//   const results = await fetch(
//     `${API_BASE_URL_DOCUMENT}/upload?objectReference=`,
//     {
//       method: 'POST',
//       body: formData,
//       headers: {
//         Authorization: `Bearer ${accessToken}`,
//       },
//     }
//   ).then((res) => {

//     if (res.status === 200) {

//       return res.json();
//       // return {
//       //   code: '200',
//       //   description: res.json(),
//       //   message: 'success',
//       // };
//     } else {
//       console.log('___test', res);
//       try {
//         res.json().then(_res=>{
//           console.log('+++',_res)
//           return{
//             code: _res.status,
//             message: _res.message,
//             description: _res.message
//           }
//         })
//       } catch(error) {
//         message.error('Error');
//       }
//       // return {
//       //   code: '500',
//       //   // description: 'error',
//       //   message: res.statusText,
//       // };
//     }
//   });

//   console.log('results', results);

//   return results;
// }
